import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FooterWrapper = styled.footer`
  width: 100%;
  margin-bottom: ${Spacing.S8};
`
